const EndPoints = {
  Auth: {
    SignIn: "Auth/SignIn",
    ForgotPassword: "Auth/ForgotPassword",
    SignInInvestor: "Auth/SignInInvestor",
    ChangePassword: "Auth/ChangePassword",
    VerifyCode: "Auth/VerifyCode",
    Logout: "Auth/Logout",
  },
  Settings: {
    GetUserMenu: "Settings/getUserMenu",
    GetUserProfile: "Settings/getUserProfile",
  },
  Lookup: {
    GetValues: "Lookup/GetValues",
    GetLookupWithValues: "Lookup/GetLookupWithValues",
    GetAllLookups: "Lookup/GetAllLookups",
    DeleteLookupValue: "Lookup/DeleteLookupValue",
    SaveLookup: "Lookup/SaveLookup",
    SaveLookupValue: "Lookup/SaveLookupValue",
    GetLookupById: "Lookup/GetLookupById",
    GetLookupValueById: "Lookup/GetLookupValueById",
  },
  OfferIssuer: {
    GetAll: "OfferIssuer/GetAll",
    GetPageList: "OfferIssuer/GetPageList",
    GetById: "OfferIssuer/GetById",
    Save: "OfferIssuer/Save",
    Delete: "OfferIssuer/Delete",
  },
  Opportunities: {
    GetPageList: "Opportunity/GetPageList",
    GetById: "Opportunity/GetById",
    Save: "Opportunity/Save",
    Delete: "Opportunity/Delete",
    GetAll: "Opportunity/GetAll",
    ExportById: "Opportunity/ExportById",
    GetFile: "Opportunity/GetFile",
  },
  Investor: {
    Save: "Investor/Save",
    Register: "Investor/Register",
    GetById: "Investor/GetById",
    GetPageList: "Investor/GetPageList",
  },
  Country: {
    GetAll: "Country/GetAll",
    GetPageList: "Country/GetPageList",
    GetById: "Country/GetById",
    Save: "Country/Save",
    Delete: "Country/Delete",
  },
  City: {
    GetAll: "City/GetAll",
    GetPageList: "City/GetPageList",
    GetById: "City/GetById",
    Save: "City/Save",
    Delete: "City/Delete",
  },
  Area: {
    GetAll: "Area/GetAll",
    GetPageList: "Area/GetPageList",
    GetById: "Area/GetById",
    Save: "Area/Save",
    Delete: "Area/Delete",
  },
  User: { 
    GetPageList: "User/GetPageList",
    GetById: "User/GetById",
    Save: "User/Save",
    Delete: "User/Delete",
  },
  Bank: {
    GetAll: "Bank/GetAll",
  },
  Suburb: {
    GetAll: "Suburb/GetAll",
    GetPageList: "Suburb/GetPageList",
    GetById: "Suburb/GetById",
    Save: "Suburb/Save",
    Delete: "Suburb/Delete",
  },
};
export default EndPoints;
